module.exports = __webpack_public_path__ + "img/eleven.99c0c1ee.svg";